module.exports = {
    sanity: {
        projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'fybyp6ub',
        dataset: process.env.GATSBY_SANITY_DATASET || 'v2',
        token: process.env.GATSBY_SANITY_READ_TOKEN,
    },
    maps: {
        apiKey: process.env.GOOGLE_MAPS_KEY,
    }
}
